import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import Image from '@synergycms_core/components/generic/Image';
import styleFile from './LoyaltyUserInfo.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { isUsDomain } from 'synergycms_core/src/utils/utils.js';

const LoyaltyUserInfo = (props) => {
  const {loyaltyUser, visible, toggle, flag, country, theme,phone } = props;
  const logined = loyaltyUser?.get('user_id');
  const { classes } = theme.styles;

  if (logined && visible) {
    return (      
      <div className={[classes.infoUserContainer].join(' ')}>
        <div className={[classes.userDataContent].join(' ')}>
          <div className={[classes.divData].join(' ')}>
            <RichText innerStyle={classes.infoTitle} translate={true} ucFirst={true} dangerouslySetInnerHTML={true} text={'_%nombre%_'} />
            <RichText ucFirst={true} text={loyaltyUser && loyaltyUser.getIn(['name'], '')} />
          </div>
          <div className={[classes.divData].join(' ')}>
            <RichText innerStyle={classes.infoTitle} translate={true} ucFirst={true} dangerouslySetInnerHTML={true} text={isUsDomain() ? '_%last_name%_' : '_%apellidos%_'} />
            <RichText ucFirst={true} text={loyaltyUser && loyaltyUser.getIn(['surname'], '')} />
          </div>
          <div className={[classes.divData].join(' ')}>
            <RichText innerStyle={classes.infoTitle} translate={true} ucFirst={true} dangerouslySetInnerHTML={true} text={'_%email%_'} />
            <RichText innerStyle={''} text={loyaltyUser && loyaltyUser.getIn(['email'], '')} />
          </div>
          <div className={[classes.divData].join(' ')}>
            <RichText innerStyle={classes.infoTitle} translate={true} ucFirst={true} dangerouslySetInnerHTML={true} text={'_%teléfono%_'} />
            <div className={classes.infoDivPhoneCountry}>
              <Image innerStyle={''} src={flag} />
              <RichText innerStyle={''} dangerouslySetInnerHTML={true} text={'+' + country + ' ' + phone} />
            </div>
          </div>
        </div>
        <div className={classes.editBtn}>          
          <Button
            onClick={toggle}            
            icon={{ unicodeContent: 'e065' , innerStyle: ['size17', 'penIcon', 'capitalize']}}
          />
        </div>
      </div>
    );
  }

  return null;
};

const mapStateToProps = (store, ownProps) => {
  const loyalty = store.getIn(['customer', 'loyalty', 'data', 'loyalty']);
  return {
    loyalty,
    type: loyalty && loyalty.get('code'),
    loyaltyUser: store.getIn(['customer', 'loyalty', 'user'])
  };
};

export default compose(
  connect(mapStateToProps),
  withThemeJSS({ styleFile, link: true, displayName: 'LoyaltyUserInfo' })
)(LoyaltyUserInfo);
